<template>
    <div ref="echart01" style="width:100%; height:200px;"></div>
  </template>
  
  <script>
  export default {
    props: {
        data12:{
            type: Object
        }
    },
    mounted() {
      let chart01 = this.$echarts.init(this.$refs.echart01)
      let xdata = this.data12.xdata
      let yData = this.data12.yData,
      barData = this.data12.barData
        let option ={}
        if (yData.length == 0||barData.length == 0 ) {  //暂无数据
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            option = {
                color: ['#2466da','#ffa207'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                legend: {
                    data: ['收入', '支出'],
                    align: 'right',
                    backgroundColor: 'rgba(242, 248, 255)'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xdata
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '总价(万元)',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    }
                ],
                series: [
                    {
                        name: '收入',
                        type: 'bar',
                        stack:"a",
                        barWidth: 15,
                        label: {
                            show: true,
                            position:"top"
                        },
                        itemStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(
                                    0,
                                    1,
                                    0,
                                    0,
                                    [
                                        {
                                            offset: 0,
                                            color: "#f9fbfe"
                                        },
                                        {
                                            offset: 1,
                                            color: "#2466da"
                                        }
                                    ],
                                    false
                                ) // 渐变
                            }
                        },
                        data: yData
                    },
                    {
                        name: '支出',
                        type: 'bar',
                        barWidth: 15,
                        stack:"a",
                        label: {
                            show: true,
                            position:"top"
                        },
                        itemStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(
                                    0,
                                    1,
                                    0,
                                    0,
                                    [
                                        {
                                            offset: 0,
                                            color: "#fffdfb"
                                        },
                                        {
                                            offset: 1,
                                            color: "#ffa207"
                                        }
                                    ],
                                    false
                                ) // 渐变
                            }
                        },
                        data: barData
                    }
                ]
            }
        }
  
      chart01.setOption(option, true)
    }
  }
  </script>
  
  <style></style>
  